import React from 'react';
import ErrorMessage from './ErrorMessage';

interface State {
  hasError: boolean;
}

class ErrorBoundary extends React.Component<unknown, State> {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return <ErrorMessage />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
